import useAsyncData from "../../../../hooks/use-async-data";
import userService from "../../user.service";
import UserDispatcherEditForm from "./user-dispatcher-edit-form";
import UserDispatcherEditFormError from "./user-dispatcher-edit-form-error";
import UserDispatcherEditFormParams from "./user-dispatcher-edit-form-params";

const useDispatcherEditForm = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<UserDispatcherEditForm | null>(null);

  const load = async (
    params: UserDispatcherEditFormParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await userService.getDispatcherEditForm(params, signal);

      setData(data);
      setIsLoading(false);
    } catch (_error) {
      const error = _error as UserDispatcherEditFormError;

      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useDispatcherEditForm;
